/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {diplomatObjectSchema} from './diplomat-object';

export const DiplomatObject = diplomatObjectSchema;
export type IDiplomatObject = yup.InferType<typeof DiplomatObject>;
